// extracted by mini-css-extract-plugin
export default {"container":"styles_container__yia0n","cta":"styles_cta__mrh6G","copy":"styles_copy__-S6RQ","copyNoMargin":"styles_copyNoMargin__8C77c"};